import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect, useRef, forwardRef, useMemo } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LabelList } from "recharts";
import { Box, Paper, Typography, Select, MenuItem, Divider } from "@mui/material";
import { getReportChartPartnerDay } from "../../redux/handlers/report/getReportChartPartnerDay.handler";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
export function ReportPartnerDay() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(new Date()), 2), selectedMonth = _useState[0], setSelectedMonth = _useState[1]; // เปลี่ยนเป็น Date object
    var _useState1 = _sliced_to_array(useState([]), 2), dataChart = _useState1[0], setDataChart = _useState1[1];
    var getReportChartPartnerDayReducer = useAppSelector(function(state) {
        return state.getReportChartPartnerDayReducer;
    });
    // Load data
    useEffect(function() {
        dispatch(getReportChartPartnerDay({
            month: moment(selectedMonth).format("YYYY-MM")
        }, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, [
        selectedMonth
    ]);
    useEffect(function() {
        setIsLoading(getReportChartPartnerDayReducer.isFetching);
        if (getReportChartPartnerDayReducer.data) {
            var _getReportChartPartnerDayReducer_data;
            setDataChart(getReportChartPartnerDayReducer === null || getReportChartPartnerDayReducer === void 0 ? void 0 : (_getReportChartPartnerDayReducer_data = getReportChartPartnerDayReducer.data) === null || _getReportChartPartnerDayReducer_data === void 0 ? void 0 : _getReportChartPartnerDayReducer_data.data);
        }
    }, [
        getReportChartPartnerDayReducer
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: "card card-st-3 mb-3",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "card-body px-xl-3",
            children: [
                /*#__PURE__*/ _jsxs(Box, {
                    sx: {
                        display: "flex",
                        alignItems: "center"
                    },
                    children: [
                        /*#__PURE__*/ _jsxs(Typography, {
                            fontSize: 16,
                            fontWeight: "bold",
                            sx: {
                                textAlign: "center",
                                flex: 1
                            },
                            children: [
                                "รายงานกราฟสะสม Partner รายวัน",
                                /*#__PURE__*/ _jsx("br", {}),
                                /*#__PURE__*/ _jsx("span", {
                                    style: {
                                        fontSize: 14,
                                        fontWeight: 400
                                    },
                                    children: moment(selectedMonth).locale("th").format("MMMM YYYY")
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Box, {
                            sx: {
                                ml: "auto"
                            },
                            children: /*#__PURE__*/ _jsx(DatePicker, {
                                selected: selectedMonth,
                                onChange: function(date) {
                                    return setSelectedMonth(date);
                                },
                                dateFormat: "MM/yyyy",
                                showMonthYearPicker: true,
                                className: "form-control body1",
                                placeholderText: "เลือกเดือน",
                                customInput: /*#__PURE__*/ _jsx("button", {
                                    type: "button",
                                    style: {
                                        padding: "8px 16px",
                                        border: "1px solid #ddd",
                                        borderRadius: "4px",
                                        background: "white",
                                        cursor: "pointer",
                                        fontSize: "14px",
                                        width: "140px"
                                    },
                                    children: moment(selectedMonth).format("MM/YYYY")
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Divider, {
                    sx: {
                        my: 2
                    }
                }),
                /*#__PURE__*/ _jsx(ResponsiveContainer, {
                    width: "100%",
                    height: 350,
                    children: /*#__PURE__*/ _jsxs(LineChart, {
                        data: dataChart,
                        children: [
                            /*#__PURE__*/ _jsx(CartesianGrid, {
                                strokeDasharray: "3 3",
                                stroke: "#ccc"
                            }),
                            /*#__PURE__*/ _jsx(XAxis, {
                                dataKey: "day",
                                tick: {
                                    fontSize: 12
                                }
                            }),
                            /*#__PURE__*/ _jsx(YAxis, {
                                tick: {
                                    fontSize: 12
                                }
                            }),
                            /*#__PURE__*/ _jsx(Tooltip, {}),
                            /*#__PURE__*/ _jsx(Legend, {
                                verticalAlign: "bottom"
                            }),
                            /*#__PURE__*/ _jsx(Line, {
                                type: "monotone",
                                dataKey: "revenueA",
                                name: "partner ใหม่",
                                stroke: "#ff9700",
                                strokeWidth: 3,
                                dot: {
                                    fill: "#ff9700",
                                    r: 5
                                },
                                activeDot: {
                                    r: 7
                                },
                                children: /*#__PURE__*/ _jsx(LabelList, {
                                    dataKey: "revenueA",
                                    position: "top",
                                    fontSize: 12,
                                    style: {
                                        fontWeight: "bold"
                                    }
                                })
                            }),
                            /*#__PURE__*/ _jsx(Line, {
                                type: "monotone",
                                dataKey: "revenueB",
                                name: "partner สะสม",
                                stroke: "#4f7df0",
                                strokeWidth: 3,
                                dot: {
                                    fill: "#4f7df0",
                                    r: 5
                                },
                                activeDot: {
                                    r: 7
                                },
                                children: /*#__PURE__*/ _jsx(LabelList, {
                                    dataKey: "revenueB",
                                    position: "top",
                                    fontSize: 12,
                                    style: {
                                        fontWeight: "bold"
                                    }
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
}
